import { TranslateService } from './../../shared/translate/translate.service';
import { AuthService } from './../../shared/models/auth.service';
import { FlatPickrModel } from './../../plugins/flatpickr/flatpickr.model';
import {
  Component,
  OnInit,
  OnChanges,
  Input,
  ViewChild,
  AfterViewInit
} from '@angular/core';
import { Router } from '@angular/router';
import { IKeyValueInterface } from './../../shared/config';
import { BookingService } from './../models/booking.service';
import { BookingOverviewList } from './../models/booking-overviewlist.model';
import {
  WeGoConfig,
  IAPIResponse,
  DataListModel,
  ApplicationRouteURL,
  BookingStatus,
  BookingType
} from '../../shared/config';
import { BookingApproveModel } from '../models/booking-approve.model';

const $ = require('jquery');
const moment = require('moment');
const SlimSelect = require('slim-select');

@Component({
  selector: 'wego-request-overview',
  template: require('../views/booking-request.component.html'),
  providers: [BookingService],
  styles: [
    `
    .search-icon {
        color:#2ba2aa;
    }
    .reset-icon {
        color:#DD9933;
    }
    .export-icon {
        color:#01A2D9;
    }
    .delete-icon {
        color:#f00;
    }
    .cancel-icon {
        color:#f00;
    }
    .add-icon {
        color:#080;
    }
    .nopad-left{
      padding-left: 0px;
    }
    `
  ]
})
export class BookingRequestComponent implements OnInit {
  //bookingStatusSpecialSelect: any;
  LblStatus: string;

  LblSelect: string;
  bookingStatusSelect: any;
  searchAdminName : string;
  BookingStatusAll: { Key: string; Value: string }[];
  itemPerPageList: number[];
  BookingStatus: { Key: string; Value: string }[];
  public dateFormat: string = WeGoConfig.FLATPICKR_DATE_TIME_FORMAT;
  apiErrorMsg: string;
  DataListModel: DataListModel;
  errorModel: IKeyValueInterface[];
  urlPersonInfo : string;
  readMore: IKeyValueInterface[];
  bookingList: BookingOverviewList[];
  isLoading: boolean;
  isParentCheck: boolean;
  message: string;
  popupMessage: string;
  remarks: string;
  flatPickrConfigFrom: FlatPickrModel;
  flatPickrConfigTo: FlatPickrModel;
  model: BookingOverviewList = new BookingOverviewList();
  isParentCheckEnable: boolean;
  remarkslength: number = 15;
  urlBooking: string;
  urlDefaultPage: string;
  urlBookingInformation: string;
  urlDriverBookingInformation: string;
  urlVehicleInfo: string;
  urlDriverInfo: string;
  urlSVGInfo: string;
  bookingHashId: string;
  recurringId: string;
  isRecurringSeriesEditablestring: boolean;
  private popupMsg: string;
  private module: string;
  bookingApproveModel: BookingApproveModel;
  SingleCancel: boolean;
  NormalBookingView: boolean = true;
  searchLicenceTag: string;
  searchDriverName: string;
  searchSVGName: string;
  bookingTypeSelect: any;
  LblSelectionRequired: string;
  SelectionRequiredMsg: string;
  successpopupMsg: string;
  approvedSuccessPopupMsg: string;
  rejectedSuccessPopupMsg: string;
  dropdownSettings = {};

  @ViewChild('remarksModal') public remarksModal: any;
  @ViewChild('EditBookingModal') public editBookingModal: any;
  @ViewChild('successPopup') public successPopup: any;
  @ViewChild('selectionRequiredPopup') public selectionRequiredPopup: any;
  @ViewChild('approveConfirnmationModal') public approveConfirnmationModal: any;
  @ViewChild('rejectReasonModal') public rejectReasonModal: any;

  get isAnyChecked(): boolean {
    if (this.bookingList) {
      let isCheck = this.bookingList.some(x => x.isChecked == true);
      if (isCheck) {
        if (
          this.bookingList
            .filter(y => y.isBookingCancel)
            .every(x => x.isChecked == true)
        )
          this.isParentCheck = true;
        else this.isParentCheck = false;
      } else {
        this.isParentCheck = false;
      }

      return isCheck;
    } else {
      this.isParentCheck = false;
      return false;
    }
  }

  constructor(
    private authService: AuthService,
    private bookigService: BookingService,
    private router: Router,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    this.module = this.translate.instant('LblBooking');
    //this.urlPersonInfo = 
    this.approvedSuccessPopupMsg = this.translate.instant(
      'LblBookingApprovedSuccessMsg'
    );
    this.rejectedSuccessPopupMsg = this.translate.instant(
      'LblBookingRejectedSuccessMsg'
    );
    this.bookingApproveModel = new BookingApproveModel();
    this.LblSelectionRequired = this.translate.instant('LblSelectionRequired');
    this.SelectionRequiredMsg = this.translate.instant('SelectionRequiredMsg');
    this.DataListModel = this.authService.RetriveFilter(this.constructor.name);
    if (this.authService.IsDriver()) {
      this.DataListModel.searchField = [
        'licenceTag',
        'reccuringID',
        'bookingStatus',
        'bookingReferenceID',
        'adminRemarks',
        'driverRemarks',
        'sharedVehicleGroup'
      ];
    } else {
    }
    this.model = new BookingOverviewList();
    this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
    this.model.endDateTime = moment()
      .add(+1, 'M')
      .format('DD-MM-YYYY 00:00');

    this.BookingStatusAll = [
      {
        Key: this.translate.instant("LblAPPROVEDBOOKINGREQUEST"),
        Value: 'CONFIRMED'
      },
      {
        Key: this.translate.instant("LblREJECTEDBOOKINGREQUEST"),
        Value: 'CANCELLED'
      },
      {
        Key: this.translate.instant("LblPENDINGBOOKINGREQUEST"),
        Value: 'PENDING'
      }
    ];

    this.BookingStatus = this.BookingStatusAll;
    this.model.bookingStatusList = this.BookingStatus.map(x => x.Value);

    console.log(this.model);

    this.model = this.authService.AssignFromStorage(
      this.constructor.name + '_model',
      this.model
    );
    this.flatPickrConfigFrom = this.SetDefaultFlatPickrConfig();
    this.flatPickrConfigTo = this.SetDefaultFlatPickrConfig();
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlPersonInfo =this.authService.GetURL(ApplicationRouteURL.URL_PERSON_UPDATE);

    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlBooking = this.authService.GetURL(ApplicationRouteURL.URL_BOOKING);
    this.urlBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION
    );
    this.urlDriverBookingInformation = this.authService.GetURL(
      ApplicationRouteURL.URL_BOOKING_INFORMATION_DRIVER
    );
    this.urlVehicleInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_VEHICLE_INFO
    );
    this.urlDriverInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_PERSON_UPDATE
    );
    this.urlSVGInfo = this.authService.GetURL(
      ApplicationRouteURL.URL_SVG_UPDATE
    );

    this.LblSelect = this.translate.instant('LblSelect');
    this.LblStatus = this.translate.instant('LblStatus');

    this.searchLicenceTag = this.model.searchLicenceTagList.join();
    this.searchAdminName = this.model.searchAdminNameList.join();
    this.searchSVGName = this.model.searchSVGNameList.join();

    this.itemPerPageList = WeGoConfig.GRID_PAGGING;
    this.DataListModel.itemsPerPage = 10;

    this.GetBookingRequestList();
  }

  private SetDefaultFlatPickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    //flatPickrConfig.enableSeconds = true;
    flatPickrConfig.dateFormat = this.dateFormat;
    flatPickrConfig.minuteIncrement = 1;
    return flatPickrConfig;
  }

  public ApproveRejectMultipleBookingRequest() {
    this.HideApproveConfirnmationModel();
    this.bookigService
      .ApproveRejectMultipleBookingRequest(this.bookingApproveModel)
      .subscribe(
        res => {
          if (res.data) {
            if (this.bookingApproveModel.isApproved)
              this.successpopupMsg = this.approvedSuccessPopupMsg;
            else this.successpopupMsg = this.rejectedSuccessPopupMsg;
            this.HideRejectReasonModel();
            this.ShowSuccessPopup();
            this.GetBookingRequestList();
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public HideApproveConfirnmationModel() {
    this.approveConfirnmationModal.hide();
  }

  public HideRejectReasonModel() {
    this.bookingApproveModel.adminRemarks='';
    this.rejectReasonModal.hide();
  }

  public OnSort(sortName: string) {
    this.DataListModel.sortType = sortName;
    this.DataListModel.sortReverse = !this.DataListModel.sortReverse;
    this.GetBookingRequestList();
  }

  public OnSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      event.searchTerm,
      event.isReset
    );
    this.GetBookingRequestList();
  }

  public OnAdvancedSearch(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      '',
      event.isReset
    );
    this.GetBookingRequestList();
  }

  public OnDateSearch() {
    this.GetBookingRequestList();
  }
  public OnPagingChange(event: any) {
    this.DataListModel.currentPage = 1;
    this.DataListModel.totalItems = 0;
    //this.DataListModel.itemsPerPage = event.itemPerPage;
    this.GetBookingRequestList();
  }
  public OnExport(event: any) {
    this.isLoading = true;
    this.bookigService
      .ExportBokingRequestList(this.model, this.DataListModel)
      .subscribe(
        (res: any) => {
          if (res && res._body) {
            let fileName = 'Booking Request' + new Date().toISOString() + '.csv';
            this.authService.DownloadFile(fileName, res._body);
          }
          this.isLoading = false;
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }
  private GetBookingRequestList() {
    this.isLoading = true;

    this.model.remarks = null;
    this.model.bookingHashId = '';
    this.model.bookingStatus = '';

    this.bookigService
      .GetBookingRequestList(this.model, this.DataListModel)
      .subscribe(
        res => {
          if (res.data) {
            this.bookingList = res.data;
            this.isParentCheckEnable =
              this.bookingList.filter(x => x.isApproverejectEnable).length > 0
                ? true
                : false;
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = res.error;
            this.isLoading = false;
            this.errorModel = null;
          } else {
            this.DataListModel.totalItems = res.totalRecords;
            this.DataListModel.infoMessage = this.translate.instant(
              'LblNoRecords'
            );
            this.errorModel = res.error;
            this.isLoading = false;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          this.isLoading = false;
        }
      );
  }

  public OnPageChanged(event: any): void {
    this.DataListModel.currentPage = event.page;
    this.GetBookingRequestList();
  }

  public OnParentCheck(isChecked: boolean) {
    this.bookingList
      .filter(y => y.isApproverejectEnable)
      .forEach(x => (x.isChecked = isChecked));
  }

  public onSubmitClick(isApprove: any) {
    this.bookingApproveModel.bookingMasterHashIds = this.bookingList
      .filter(x => x.isChecked)
      .map(x => x.bookingHashId);

    if (this.bookingApproveModel.bookingMasterHashIds.length == 0) {
      this.selectionRequiredPopup.show();
      return false;
    }

    this.bookingApproveModel.isApproved = isApprove == 1 ? true : false;
    if (this.bookingApproveModel.isApproved)
      this.approveConfirnmationModal.show();
    else this.rejectReasonModal.show();
  }

  //Addedd for remarksModal
  public ShowRemakrsModal(remarks: string) {
    this.remarks = remarks;
    this.remarksModal.show();
  }
  public HideRemarksModal() {
    this.remarks = null;
    this.remarksModal.hide();
  }

  public SuccessSingleBooking(): void {
    this.editBookingModal.hide();
    this.router.navigate([
      this.urlBooking,
      { ref: this.bookingHashId, isRecurring: false }
    ]);
  }

  public SuccessRecurringBooking(): void {
    this.editBookingModal.hide();
    this.router.navigate([
      this.urlBooking,
      { ref: this.recurringId, isRecurring: true }
    ]);
  }

  public HideBookingModal(): void {
    this.editBookingModal.hide();
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
  }

  ngOnDestroy() {
    this.authService.SetFilter(this.constructor.name, this.DataListModel);
    this.authService.SaveToStorage(
      this.constructor.name + '_model',
      this.model
    );
  }

  public OnAdvancedReset(event: any) {
    this.DataListModel = this.authService.GetSearchParameters(
      this.DataListModel,
      '',
      event.isReset
    );

    this.model.searchAdminNameList = [];
    this.searchAdminName = '';
    this.model.adminHashIdList = [];
    this.searchDriverName = '';
    this.model.driverHashId = '';
    this.model.adminHashId = '';
    this.model.searchLicenceTagList = [];
    this.searchLicenceTag = '';
    this.model.vehicleHashId = '';
    this.model.searchSVGNameList = [];
    this.searchSVGName = '';
    this.model.sharedVehicleGroupHashId = '';
    this.model.startDateTime = moment().format('DD-MM-YYYY 00:00');
    this.model.endDateTime = moment()
      .add(+1, 'M')
      .format('DD-MM-YYYY 00:00');
    this.model.bookingReferenceId = '';
    this.model.bookingStatus = '';
    this.model.searchAdminNameList = [];
    this.searchDriverName = '';
    this.model.searchLicenceTagList = [];
    this.searchLicenceTag = '';
    this.model.searchSVGNameList = [];
    this.searchSVGName = '';

    this.model.sharedVehicleGroupHashIdList = [];
    this.model.vehicleHashIdList = [];
    this.model.driverHashIdList = [];

    this.model.bookingStatusList = this.BookingStatus.map(x => x.Value);
    this.bookingStatusSelect.set(this.model.bookingStatusList);

    this.NormalBookingView = true;
    this.GetBookingRequestList();
  }

  public BookingStatusChanged() {}

  public SuccessSelectVehicleModal($event: any) {
    this.model.searchLicenceTagList = $event.LicenceTage;
    this.searchLicenceTag = this.model.searchLicenceTagList.join();
    this.model.vehicleHashIdList = $event.VehicleMasterHashID;
  }

  public SuccessSelectAdminModal($event: any) {
    this.model.searchAdminNameList = $event.UserName;
    this.searchAdminName = this.model.searchAdminNameList.join();
    this.model.adminHashIdList = $event.PersonHashID;
  }

  public SuccessSelectDriverModal($event: any) {
    this.model.searchDriverNameList = $event.DriverName;
    this.searchDriverName = this.model.searchDriverNameList.join();
    this.model.driverHashIdList = $event.DriverHashID;
  }

  public SuccessSelectSvgModal($event: any) {
    this.model.searchSVGNameList = $event.SvgName;
    this.searchSVGName = this.model.searchSVGNameList.join();
    this.model.sharedVehicleGroupHashIdList = $event.SvgMasterHashID;
  }

  public ClearDriver() {
    this.model.searchDriverNameList = [];
    this.searchDriverName = '';
    this.model.driverHashId = '';
    this.model.driverHashIdList = [];
  }
  public ClearAdmin() {
    this.model.searchAdminNameList = [];
    this.searchAdminName = '';
    this.model.adminHashId = '';
    this.model.adminHashIdList = [];
  }

  public ClearVehicle() {
    this.model.searchLicenceTagList = [];
    this.searchLicenceTag = '';
    this.model.vehicleHashId = '';
    this.model.vehicleHashIdList = [];
  }
  public ClearSvg() {
    this.model.searchSVGNameList = [];
    this.searchSVGName = '';
    this.model.sharedVehicleGroupHashId = '';
    this.model.sharedVehicleGroupHashIdList = [];
  }

  ngAfterViewInit() {
    this.RenderBookingStatus();
    this.bookingStatusSelect.set(this.model.bookingStatusList);
  }

  private RenderBookingStatus() {
    this.bookingStatusSelect = new SlimSelect({
      select: '#bookingStatus',
      placeholder: this.LblSelect + ' ' + this.LblStatus,
      showSearch: false,
      showContent: 'down',
      onChange: (info: any) => {
        this.model.bookingStatusList = info.map((x: any) => x.value);
      }
    });
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/booking/components/booking-request.component.ts